import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  codeContainer: {
    alignSelf: 'center',
    maxWidth: theme.spacing(20),
    background: 'white',
    marginBottom: theme.spacing(1),
    padding: theme.spacing(1),
  },
  code: {
    height: 'auto',
    maxWidth: '100%',
  },
  codeHint: {
    color: theme.palette.text.disabled,
    alignSelf: 'center',
  },
  inputContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  inputLabel: {
    alignSelf: 'start',
    marginBottom: theme.spacing(1),
  },
}));
